enum InternalEvents {
  SEND_TOKENS = 'SEND_TOKENS'
}

export default InternalEvents;
